import { Accordion, AccordionDetails, AccordionSummary, Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ScutInfo = ({ productos, open, setOpen }) => {

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
        >
            <DialogTitle sx={{ m: 0, p: 2, width: '480px' }} id="customized-dialog-title">
                Códigos de ingreso abreviado
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent dividers>
                <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                    <TableRow>
                        <TableCell >Código</TableCell>
                        <TableCell >Producto</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {productos.map((p, n) => {
                        if (p.scut.length > 0)
                            return (
                                <TableRow key={n}>
                                    <TableCell ><b>{p.scut}</b></TableCell>
                                    <TableCell >{p.product}</TableCell>
                                </TableRow>
                            )
                    })}
                    </TableBody>    
                </Table>
                </TableContainer>

                <Accordion sx={{marginTop: 3}}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        Instrucciones de Uso
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography align="justify" color='#444'>
                            En la ventana "Código de Barras" se debe ingresar el <b>código abreviado</b> y presionar Enter.
                            Para ingresar un número determinado de productos, se puede colocar un número después del código, número que determinará
                            la cantidad de productos a ingresar.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleClose}>
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ScutInfo